import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button ,DropdownItem , DropdownMenu , Nav , NavItem, Dropdown , DropdownToggle} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";
import IconEdit from 'react-icons/lib/md/edit';
import IconPersonAdd from 'react-icons/lib/md/person-add';

import * as actions from '../../actions/almacenes';
// import Modal from "./Modal";
import _ from "lodash";
import {api} from '../../actions/_request';

const movimientos =[
         'Entrada',
         'Salida',
         'Transferencia',
         'Devolución al Proveedor',
         'Devolución del Cliente'
    ];


const requestData = (pageSize, page, sorted, filtered) => {    
    return new Promise((resolve, reject) => {
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;

        var concepto="";
        var referencia="";
        var fecha="";
        var almacen="";
        var procli="";


        var take= pageSize;
        var skip=pageSize * page;
        var total=1;  
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
            case "concepto":
              concepto=filtered[i].value;
              break;
            case "referencia":
              referencia=filtered[i].value;
              break;            
            case "almacen":
              almacen=filtered[i].value;
              break;
            case "fecha":
              fecha=filtered[i].value;
              break;     
            case "procli":
              procli=filtered[i].value;
              break;        
          }
        }
        api().get(`/movimientosalmacenes/conteo?almacen=${almacen}&concepto=${concepto}&referencia=${referencia}&fecha=${fecha}&procli=${procli}&take=${take}&skip=${skip}`)
        .then(function(response)
        {
            if(response.status === 200)
            {
              total= response.data[0].total; 
              api().get(`/movimientosalmacenes/busqueda?almacen=${almacen}&concepto=${concepto}&referencia=${referencia}&fecha=${fecha}&procli=${procli}&take=${take}&skip=${skip}`)
              .then(function(response)
              {
                if(response.status === 200)
                {
                  filteredData= response.data; 
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  //console.log(res);
                  resolve(res)
                }
              });   
            }
        });
    });
};
class Descuentos extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
             data: [],
             pages: null,
             loading: true

        };
        this.toggle 			= this.toggle.bind(this);
        this.opciones       = this.opciones.bind(this);
        this.fetchData = this.fetchData.bind(this);
    }
    get_cliente(cliente = null){
    
    
          
  
  }
 fetchData(state, instance) {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered
    ).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      this.setState({
        data: res.rows,
        pages: res.pages,
        loading: false
      });
      this.props.get(res.rows);
    });
  }
   opciones( id = null, title = "Agregar Almacen", tipo=0)
    {
        this.props.formulario(id,title,tipo);
    }

  toggle(menu,id) {
    let valor=0;

    if(menu===1){
      if(parseInt(this.state.menu)!==id)
        valor=id;
        this.setState({
          menu: valor
        });
    }else{
      if(parseInt(this.state.submenu)!==id)
        valor=id;
        this.setState({
          submenu: valor
        });
    }
  }

    componentDidMount() {

       // this.props.get();
    }

    render() {
        const { data, pages, loading } = this.state;
        return(
            <div className="view">
           

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Movimientos de Almacen</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                        <div className="row justify-content-end">
                          <div className="col-3 mb-4">
                            <div className="mr-5 text-right float-right">
                                <Dropdown nav isOpen={parseInt(this.state.menu)===1?true:false} toggle={() => {this.toggle(1,1);}} >
                                  <DropdownToggle nav caret>
                                   Agregar
                                  </DropdownToggle>
                                  <DropdownMenu className='letras_menu'>
                                    <DropdownItem onClick={() => {this.opciones(null,'Entrada',1);}}>Entradas</DropdownItem>
                                    <DropdownItem onClick={() => {this.opciones(null,'Salida',2);}}>Salida</DropdownItem>
                                    <DropdownItem onClick={() => {this.opciones(null,'Transferencia',3);}}>Transferencia</DropdownItem>
                                    <DropdownItem onClick={() => {this.opciones(null,'Devolución al proveedor',4);}}>Devolución al proveedor</DropdownItem>
                                    <DropdownItem onClick={() => {this.opciones(null,'Devolución al cliente',5);}}>Devolución del cliente</DropdownItem>
                                  </DropdownMenu>
                                </Dropdown> 
                            </div>
                          </div>
                        </div>
                            <ReactTable
                              getTrProps={(state, rowInfo, column) => {
                                  
                                  if(rowInfo === undefined){
                                          
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (evt)=>this.opciones(rowInfo.original.value, movimientos[parseInt(rowInfo.original.tipo_movimiento_id)-1],rowInfo.original.tipo_movimiento_id)
                                        } 
                                  
                                    }
                              }}
                             
                              className = "-striped -highlight"
                              columns   = {[
                               
                               
                                {Header: 'Concepto', accessor: 'concepto',maxWidth:150,minWidth:150},
                                {Header: 'Referencia', accessor: 'referencia',maxWidth:150,minWidth:150},
                                {Header: 'Fecha', accessor: 'fecha',maxWidth:150,minWidth:150},
                                {Header: 'Almacen', accessor: 'almacen',maxWidth:150,minWidth:150},
                                {Header: 'Ref Doc', accessor: 'referencia',filterable: false, sortable: false},
                                {Header: 'ProCli', accessor: 'procli',minWidth:500 },
                                {Header: 'Existencia', accessor: 'usuar', filterable: false, sortable: false,maxWidth:150,minWidth:150},
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:150,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                                <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.opciones(row.original.value, movimientos[parseInt(row.original.tipo_movimiento_id)-1],row.original.tipo_movimiento_id)}>
                                                    <IconEdit />
                                                </Button>{' '}
                                                 
                                            </div>
                                        )
                                    }
                                }
                              
                              ]}
                            
                              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                              data={this.props.almacenes.data}
                              pages={pages} // Display the total number of pages
                              loading={loading} // Display the loading overlay when we need it
                              onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change
                              filterable
                              defaultPageSize={10}
                             
                              
                             
                            />
                        </CardBlock>
                    </Card>
                </div>                

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        almacenes : state.almacenes,
    }
};

export default connect(mapStateToProps, actions)(Descuentos)


// WEBPACK FOOTER //
// ./src/views/movimientosAlmacenes/tabla.js